import RadioField from "./RadioField";
import DropdownField from "./DropdownField";
import ButtonField from "./ButtonField";

const Field = ({ type, ...props }) => {
  switch (type) {
    case "radio":
      return <RadioField {...props} />;
    case "dropdown":
      return <DropdownField {...props} />;
    case "button":
      return <ButtonField {...props} />;
    default:
      return null;
  }
};

export default Field;
